<app-header></app-header>

<bit-container>
  <div class="bv-security-page">
    <bit-tab-nav-bar class="bv-security-tabs">
      @if (showChangePassword) {
        <bit-tab-link [route]="changePasswordRoute">{{ "masterPassword" | i18n }}</bit-tab-link>
      }
      <bit-tab-link route="two-factor">{{ "twoStepLogin" | i18n }}</bit-tab-link>
      <bit-tab-link route="device-management">{{ "devices" | i18n }}</bit-tab-link>
      <bit-tab-link route="security-keys">{{ "keys" | i18n }}</bit-tab-link>
    </bit-tab-nav-bar>

    <div class="bv-security-page__content">
      <router-outlet></router-outlet>
    </div>
  </div>
</bit-container>
